import * as React from 'react';

import type {DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers as StartTrigger} from 'nutshell-graphql-types';

import {CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS} from '../../constants';

import {DripSequenceStartTriggerCard} from '../cards/drip-sequence-start-trigger-card';
import {SalesAutomationCardEmailWrapper} from '../cards/sales-automation-card-email-wrapper';
import {SalesAutomationStretchCard} from '../cards/sales-automation-stretch-card';

import {CardsContainer} from './cards-container';

type Props = {
    parentId: string;
    isLoading: boolean;
    hideCards: boolean;
    isFirstStage: boolean;
    // @ts-expect-error
    errorMessage: string | React.ReactElement<React.ComponentProps<string>> | null | undefined;
    startTriggers: StartTrigger | null | undefined[];
    numberOfStagesSpanned: number;
};

export class StageCardsStartTriggers extends React.PureComponent<Props> {
    render() {
        // @ts-expect-error
        const cards = this.props.startTriggers.map((startTrigger, index) => {
            if (!startTrigger) {
                return (
                    <SalesAutomationCardEmailWrapper
                        key={`${index}-${this.props.parentId}`}
                        isHidden={this.props.hideCards}
                        size='medium'
                    />
                );
            }

            return (
                <SalesAutomationStretchCard
                    key={startTrigger.id}
                    stageId={this.props.parentId}
                    entityId={startTrigger.campaign.id}
                    type={CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS}
                    isDisabled={false}
                    isHidden={false}
                    size='medium'
                    isFirstStage={this.props.isFirstStage}
                    numberOfStagesSpanned={this.props.numberOfStagesSpanned}
                    alignTop={true}
                >
                    <DripSequenceStartTriggerCard startTrigger={startTrigger} />
                </SalesAutomationStretchCard>
            );
        });

        return (
            <CardsContainer
                type={CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS}
                isLoading={this.props.isLoading}
                hideAddCard={this.props.hideCards}
                errorMessage={this.props.errorMessage}
                isCardBeingDragged={false}
                parentId={this.props.parentId}
            >
                {cards}
            </CardsContainer>
        );
    }
}
